module.exports = __webpack_public_path__ + "static/media/position-icon-grey.4aae95fd.svg";